/**
 * Validate a structured link href (LinkValue.href): allow relative URLs and
 * http(s)/mailto/tel — never javascript:, data: or other active schemes.
 * Client-safe (no dependencies); the server sanitizer re-exports it too.
 */
export function safeHref(href: string | undefined | null): string | null {
  if (!href) return null;
  const value = href.trim();
  if (/^[/#?]/.test(value)) return value; // relative path, hash or query
  if (/^(https?:|mailto:|tel:)/i.test(value)) return value;
  return null;
}
